export function parseProjectNameFromUrl(host) {
  return host.split(".")[0].split("-")[0];
}
